import {
    REPORT_PARAM_TYPE_REQUEST_GET,
    REPORT_PARAM_TYPE_RESPONSE_GET_SUCCESS,
    REPORT_PARAM_TYPE_RESPONSE_GET_FAIL,
	REPORT_PARAM_INTERVAL_REQUEST_GET,
	REPORT_PARAM_INTERVAL_RESPONSE_GET_SUCCESS,
	REPORT_PARAM_INTERVAL_RESPONSE_GET_FAIL,
	REPORT_PARAM_PERIOD_REQUEST_GET,
	REPORT_PARAM_PERIOD_RESPONSE_GET_SUCCESS,
	REPORT_PARAM_PERIOD_RESPONSE_GET_FAIL,
} from '../../constants/maintenance/reportsParamConstants';

export const reportsParamTypeListReducer = (state = { typeList: {} }, action) => {
	switch (action.type) {
		case REPORT_PARAM_TYPE_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case REPORT_PARAM_TYPE_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				typeList: action.payload,
			};
		case REPORT_PARAM_TYPE_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const reportsParamIntervalListReducer = (state = { intervalList: {} }, action) => {
	switch (action.type) {
		case REPORT_PARAM_INTERVAL_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case REPORT_PARAM_INTERVAL_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				intervalList: action.payload,
			};
		case REPORT_PARAM_INTERVAL_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const reportsParamPeriodListReducer = (state = { periodList: {} }, action) => {
	switch (action.type) {
		case REPORT_PARAM_PERIOD_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case REPORT_PARAM_PERIOD_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				periodList: action.payload,
			};
		case REPORT_PARAM_PERIOD_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};